import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { pendingActionsManager } from '@/services/PendingActionsManager';
import { postLoginRefreshManager } from '@/services/PostLoginRefreshManager';
import { usePostLoginRefresh } from '@/hooks/usePostLoginRefresh';

export const useAuthStateListener = () => {
  const { user } = useAuth();
  
  // Initialize React Query cache invalidation
  usePostLoginRefresh();

  useEffect(() => {
    if (user) {
      console.log('User authenticated, starting post-login refresh sequence');
      
      const executePostLoginSequence = async () => {
        try {
          // Step 1: Execute pending actions first (high priority)
          console.log('Step 1: Executing pending actions...');
          await pendingActionsManager.executeActions();
          
          // Step 2: Execute all registered refresh callbacks
          console.log('Step 2: Executing data refresh callbacks...');
          await postLoginRefreshManager.executeAll();
          
        } catch (error) {
          console.error('Error in post-login sequence:', error);
        }
      };

      // Small delay to ensure all contexts are initialized
      setTimeout(executePostLoginSequence, 100);
    }
  }, [user]);

  return { 
    isAuthenticated: !!user,
    isRefreshing: postLoginRefreshManager.getIsRefreshing()
  };
};